import {Component, Input, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {faDownload} from '@fortawesome/free-solid-svg-icons';
import {
  IrbAgGridExportService
} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service";


@Component({ standalone: false,
  selector: 'irb-com-portfolio-history',
  templateUrl: './com-portfolio-history.component.html',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComPortfolioHistoryComponent implements OnInit {

  isUiTest = false;
  gridOptions: any;
  grid: any;
  hasServerSideDatasource: boolean = false;
  faDownload = faDownload;
  @Input() portfolioId: any;

  constructor(private ies: IrbEditorsService, public ges: IrbAgGridExportService) {
  }
  ngOnInit() {
    const colDef: any = this.getSecColumnDefs();
    let rowIdIteration = -1;
    this.gridOptions = {
      sortModel: [
        {colId: 'createdDate', sort: 'desc'}
      ],
      columnDefs: colDef,
      rowModelType: 'serverSide',
      floatingFilter: false,
      overlayLoadingTemplate: "<div class='loading-spinner'></div>",
      overlayNoRowsTemplate: "No results found.",
      context: {componentParent: this},
      getRowId: (params: any) => {
        rowIdIteration++;
        const rowId = 'RowId' + rowIdIteration;
        return params.data.portfolioId + rowId;
      },
      onSortChanged: () => {
        if (!this.hasServerSideDatasource) {
          this.grid.api.setGridOption('serverSideDatasource', this.setDatasource());
        }
      }
    };
  }

  private getSecColumnDefs() {
    return [
      {
        headerName: "Timestamp",
        field: "createdDate",
        cellRenderer: 'cellRendererFormatter',
        cellRendererParams: {type: 'date', format: 'MM/dd/yyyy h:mm a', displayETtext: true},
        minWidth: 150,
        suppressMovable: true
      },
      {
        headerName: "User",
        field: "modifiedBy",
        minWidth: 70,
        cellRenderer: 'cellRendererFormatter',
        suppressMovable: true,
        tooltipValueGetter: (params: any) => (params.value ? params.value : null)
      },
      {
        headerName: "Attribute",
        field: "attributeName",
        minWidth: 50,
        cellRenderer: 'cellRendererFormatter',
        suppressMovable: true,
        tooltipValueGetter: (params: any) => (params.value ? params.value : null)
      },
      {
        headerName: "Previous Value",
        field: "previousValue",
        minWidth: 70,
        suppressMovable: true,
        valueFormatter: (params: any) => {
          return params.value ? params.value : '-';
        },
        tooltipValueGetter: (params: any) => (params.value ? params.value : null)
      },
      {
        headerName: "Updated Value",
        field: "updatedValue",
        suppressMovable: true,
        valueFormatter: (params: any) => {
          return params.value ? params.value : '-';
        },
        tooltipValueGetter: (params: any) => (params.value ? params.value : null)
      }
    ];
  }

  onGridReady(params: any) {
    this.grid = params;

    if (!this.hasServerSideDatasource) {
      this.grid.api.setGridOption('serverSideDatasource', this.setDatasource());
    }
  }

  setDatasource() {
    this.hasServerSideDatasource = true;
    return {
      getRows: (params: any) => {
        this.ies.getPortfolioHistory(params, this.portfolioId).subscribe((response: any) => {
          let gridData: any = [];
          if (response && Array.isArray(response))
            gridData = response;

          if (gridData.length === 0) {
            this.grid.api.showNoRowsOverlay();
          } else {
            this.grid.api.hideOverlay();
          }
          
          params.success({rowData: gridData});
        }, () => {
          this.grid.api.showNoRowsOverlay();
        });
      }
    }
  }
  exportHistory() {
    this.ies.exportPortfolioHistory(this.portfolioId).subscribe((_res: any) => {
      this.ges.showSuccessMessage();
    },()=>{});
  }
}
